import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { DynamicForm } from '../../DynamicForm';
import * as v from '../../../helpers/validation';
import { Paper } from '@material-ui/core';
import classnames from 'classnames';
// SERVICES
import { createClientUser, getClientList } from '../../../services';

const styles = props => ({ paper: { padding: '24px', boxSizing: 'border-box' } });

export const ClientUsersCreate = withStyles(styles)(({ classes }) => {
  const [clientList, setClientList] = useState([]);

  useEffect(() => {
    getClientListAsync();
  }, []);

  const getClientListAsync = async () => {
    let clients = await getClientList();
    clients = clients.map(c => {
      return {
        value: c.id,
        label: `${c.name} ${c.code && `(${c.code})`}`,
      };
    });
    setClientList(clients);
  };

  const clientUserInputs = [
    {
      inputType: 'gridcontainer',
      children: [
        {
          inputType: 'griditem',
          children: [
            {
              inputType: 'select',
              field: 'clientId',
              label: 'Client',
              validate: [v.required()],
              options: clientList,
            },
            {
              inputType: 'text',
              field: 'email',
              label: 'Email',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'userName',
              label: 'Username',
              validate: [v.required()],
            },
            {
              inputType: 'password',
              field: 'password',
              label: 'Password',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'fname',
              label: 'First Name',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'mname',
              label: 'Middle Name',
              validate: [],
            },
            {
              inputType: 'text',
              field: 'lname',
              label: 'Last Name',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'title',
              label: 'Title',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'company',
              label: 'Company',
              validate: [v.required()],
            },
          ],
        },
      ],
    },
  ];

  return (
    <Paper className={classnames(classes.paper, 'border-left-green')} elevation={1}>
      <DynamicForm
        inputs={clientUserInputs}
        mode={'CREATE'}
        onSave={createClientUser}
        redirectOnSuccess={'/users/client'}
      />
    </Paper>
  );
});
